export * from './getStyle';
